<div class="kz-plan3D-fullscreen" data-tab="dashboard">
  <div class="kz-plan3D-fs--main">
    <!-- Main - Medias -->
    <app-kazaplan-fullscreen-diapo></app-kazaplan-fullscreen-diapo>
  </div>

  <div class="kz-plan3D-fs--sidebar">
    <ng-container *ngIf="(kfs.getCurrentKazaplan() | async) as plan">
      <!-- todo : if user.pro > redirect to /pro/job/brand/3Dplan-->
      <a *ngIf="plan.kaza" [routerLink]="(plan.kaza['@id'] | kazaLink: '3Dplan') | localize" class="kz-plan3D-fs--sidebar--go-to-kaza" kzButton buttonContext="tools"><span>Retour</span></a>
    </ng-container>

    <!-- Sidebar - Medias -->
    <app-kazaplan-fullscreen-sidebar-medias></app-kazaplan-fullscreen-sidebar-medias>

  </div>
</div>
